<app-modal
  [title]="'Gutschein' | trans:'vouchers/voucher-actions-modal/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div class="d-grid gap-12">
      <button
        class="button button--quick-action"
        (click)="openVoucherDetails()"
      >
        <i class="ri-information-line"></i>
        {{ 'Voucher Details' | trans:'vouchers/voucher-actions-modal/buttons/voucherDetails.Button' }}
      </button>

      <button
        class="button button--quick-action"
        (click)="openCancelVoucher()"
      >
        <i class="ri-close-circle-line"></i>
        {{ 'Cancel Voucher' | trans:'vouchers/voucher-actions-modal/buttons/cancelVoucher.Button' }}
      </button>

      <button
        class="button button--quick-action"
        (click)="openInvalidateVoucher()"
      >
        <i class="ri-close-circle-line"></i>
        {{ 'Invalidate Voucher' | trans:'vouchers/voucher-actions-modal/buttons/invalidateVoucher.Button' }}
      </button>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel'| trans:'vouchers/voucher-actions-modal/cancel.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-voucher-code-input-modal
  #voucherCodeInputModalComponent
  (codeSubmitted)="onVoucherCodeSubmitted($event)"
  (cardDetailsRequested)="onCardDetailsRequested($event)"
/>

<app-voucher-details-modal #voucherDetailsModalComponent />

<app-card-details-modal #cardDetailsModalComponent></app-card-details-modal>
